module.exports = __webpack_public_path__ + "img/kankou_19.cd430812.jpg";